'use client'
import { createContext, memo, useEffect, Dispatch, SetStateAction } from 'react'
import styled from 'styled-components'
import { AnimatePresence, motion, useMotionValue, useSpring } from 'motion/react'
import { mq, presets } from '@/styles'

export type TypeCursor = {
  readonly visible: boolean,
  readonly text: string
}

type CursorContextType = {
  cursorData: TypeCursor,
  setCursorData: Dispatch<SetStateAction<TypeCursor>>
}

export const CursorContext = createContext<CursorContextType | null>(null)

export const Cursor = memo(({ data }: { data: TypeCursor }) => {
  const { visible, text } = data
  const cursorX = useMotionValue(-100)
  const cursorY = useMotionValue(-100)

  const springConfig = { damping: 100, mass: 1, stiffness: 3000 }
  const cursorXSpring = useSpring(cursorX, springConfig)
  const cursorYSpring = useSpring(cursorY, springConfig)

  useEffect(() => {
    const moveCursor = (e) => {
      cursorX.set(e.clientX)
      cursorY.set(e.clientY)
    }
    window.addEventListener('mousemove', moveCursor)
    return () => { window.removeEventListener('mousemove', moveCursor) }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (<AnimatePresence>
    {visible && <Div exit={{ opacity: 0 }} style={{ x: cursorXSpring, y: cursorYSpring }}>
      <span>{text}</span>
    </Div>}
  </AnimatePresence>
  )
})

const Div = styled(motion.div)`
  ${presets.font15}
  color: white;
  display: none;
  left: 80px;
  pointer-events: none;
  position: fixed;
  top: 20px;
  text-transform: capitalize;
  transition: 100ms opacity ease-out;
  white-space: nowrap;
  z-index: 9999;
  mix-blend-mode: difference;

  ${mq.greaterThan('tablet')} {
    display: block;
    mix-blend-mode: difference;
  }

  span {
    mix-blend-mode: difference;
    position: absolute;
    transform: translateX(-50%);
  }
`
